import { useErrorSnackbar } from './use-error-snackbar'
import { useTranslation } from 'react-i18next'

export const useHandleMutationError = (
  MODULE_NAME: string
): {
  handleError: (args: { error: any; keyPrefix: string }) => boolean
} => {
  const [showError] = useErrorSnackbar()
  const { i18n } = useTranslation(MODULE_NAME)

  const handleError = ({
    error,
    keyPrefix,
  }: {
    error: any
    keyPrefix: string
  }): boolean => {
    if (error.graphQLErrors?.length > 0) {
      const message = error.graphQLErrors[0].message
      if (
        message &&
        i18n.exists(`${keyPrefix}.${message}`, {
          ns: MODULE_NAME,
        })
      ) {
        showError(
          i18n.t(`${keyPrefix}.${message}`, {
            ns: MODULE_NAME,
          })
        )
        return true
      }
    }
    return false
  }

  return { handleError }
}
